export const rj = {
  companyName: 'FlySync',
  corporateName: 'Rajesh',
  title: 'Rajesh Travels',
  templateConfig: 'template1',
  email: 'support@rajeshtravelss.com',
  phone: '9302300600',
  address:
    '<div>No. 15, Thiruneelakandan Nagar,<br>Main Road Kavangrai, Puzhal,<br>Chennai, Tamil Nadu - 600066, <br>India</div>',
  apiUrl: 'https://b2b.rajeshtravelss.com/backend/',
  isFullBGimage: 'Y',
  loginBanner: 'N',
  whatsapp: '9025300600',
  isHotel: false,
  poweredBy: false,
  agentNavigate: 'https://b2b.rajeshtravelss.com/auth/login',
  instagram:
    'https://www.instagram.com/rajesh__travels/?igsh=MXEyb2RlM2pvNzdw#',
  facebook: 'https://www.facebook.com/rajeshtravels1',
  twitter: 'https://x.com/Rajeshtravelss',
  linkedin: 'https://www.linkedin.com/company/rajeshtravels',
  youtube: 'https://www.youtube.com/@rajeshtravelss',
  sentryDsn:
    'https://67269001d7387ce208d73a9eb29708e3@o4509110763126784.ingest.us.sentry.io/4509110770663424',
  registerAddress: '',
  registerCompanyName: '',
  registerEmail: '',
  registerMobile: '',
  registerNo: '',
  providerCodes: ['BTT', 'RJ', 'KT', 'MP', 'FB', 'AIQ'],
  cancellationCharges: '{"DO":"250","IN":"500"}',
  encrypt: 'N',
  securePayment: 'true',
  encryptionSecretKey: 'd1e622507595486ee06db24b1debf11064edd2ba',
};
